import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import TKFilterGroupWrapper from '@tk/components/tk.filter.group.wrapper';
import TKFilter from '@tk/components/tk.filter';

export default class TKFilterDrilldownButton extends TKCustomElementFactory {
    activeFilterCountWrapper?: HTMLElement;
    tkFilter?: TKFilter;
    tkFilterGroupWrapper?: TKFilterGroupWrapper;
    activeFilterClass: string;
    openDrilldownClass: string;
    testClassName?: string;

    constructor() {
        super();

        this.openDrilldownClass = this.getAttribute('data-tk-filter-drilldown-open-class')
            || 'tk-filter-group-wrapper--drilldown';
        this.activeFilterClass = this.getAttribute('data-tk-filter-drilldown-active-class')
            || 'tk-filter-drilldown-button--active';
        this.activeFilterCountWrapper = this.querySelector('[data-tk-filter-drilldown-button-count]') || undefined;
        this.tkFilter = this.closest('tk-filter') || undefined;
    }

    connectedCallback(): void {
        if (!this.activeFilterCountWrapper || !this.tkFilter) return;
        this.tkFilterGroupWrapper = this.tkFilter.querySelector('tk-filter-group-wrapper') || undefined;
        if (!this.tkFilterGroupWrapper) return;
        this.registerClickListener();
        this.registerFilterListener();
        this.updateFilterCount();
    }

    registerClickListener(): void {
        const handleDrilldownToggle = this.toggleDrilldown.bind(this);
        this.pushListener({ event: 'click', element: this, action: handleDrilldownToggle });
    }

    registerFilterListener(): void {
        this.tkFilter?.subscribe((data) => {
            if (data.action === 'REFRESHED') {
                this.updateFilterCount();
            }
        });
    }

    toggleDrilldown(): void {
        this.tkFilterGroupWrapper!.classList.add(this.openDrilldownClass);
        this.tkFilterGroupWrapper!.showAllGroups();
    }

    updateFilterCount(): void {
        const activeFilters = [...new Set(this.tkFilter!.filterList.map((filter) => filter.id))];
        if (activeFilters.length > 0) {
            this.activeFilterCountWrapper!.innerHTML = `${activeFilters.length}`;
            this.classList.add(this.activeFilterClass);
        } else {
            this.activeFilterCountWrapper!.innerHTML = '';
            this.classList.remove(this.activeFilterClass);
        }
    }
}
